/**
 * Hash a string using the SHA-256 algorithm
 *
 * Code copied from https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/digest#converting_a_digest_to_a_hex_string
 */
export const getSha256Hash = async (content: string) => {
  const msgUint8 = new TextEncoder().encode(content); // encode as (utf-8) Uint8Array
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8); // hash the message
  const hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
  const hashHex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join(''); // convert bytes to hex string
  return hashHex;
};

export const hashToFloat = (hash: string, chars: number = 4): number => {
  if (hash.length < chars) {
    // Handle cases where the hash might be too short (shouldn't happen with SHA256, but good for robustness)
    console.warn(`Hash is shorter than ${chars} characters. Returning 0.`);
    return 0;
  }

  const lastChars = hash.slice(-chars);

  // 3. Convert Hexadecimal to Decimal
  // parseInt(string, radix) is used here. radix 16 for hexadecimal.
  const decimalValue = parseInt(lastChars, 16);

  const maxHexCharString = 'F'.repeat(chars);
  const maxValue = parseInt(maxHexCharString, 16);

  if (maxValue === 0) {
    // Prevent division by zero, though highly unlikely here
    return 0;
  }

  const floatValue = decimalValue / maxValue;

  return floatValue;
};
